module.exports = __webpack_public_path__ + "img/gif.271adca.svg";